import { Form } from "react-router";
import Button from "~/components/lib/Button";
import { SearchIcon } from "~/components/lib/icons";
import Input from "~/components/lib/Input";

type Props = {
  query?: string;
};

const Search: React.FC<Props> = ({ query }) => (
  <Form
    method="get"
    action="/blog"
    role="search"
    className="blog-sidebar__search"
  >
    <Input
      key={query}
      name="q"
      placeholder="Search Articles"
      defaultValue={query}
      className="blog-sidebar__search-input"
    />
    <Button
      type="submit"
      icon={["left", SearchIcon]}
      aria-label="Search"
      className="blog-sidebar__search-button"
    />
  </Form>
);

export default Search;
